module.exports = __webpack_public_path__ + "media/images/game/fin_index-f1e2092954c2fb9920e9e82604e718d9.png";